import cec from '@/module/interactionCenter/page/cec/manage.vue'
import layout from '@/layout/index'
import i18n from '@/lang/index'
// 导出配置的路由器
export default [{
  path: '/interactionCenter',
  component: layout,
  redirect: 'interactionCenter/cec',
  meta: {
    title: i18n.t('jiao-hu-zhong-xin'),
    icon: 'icon-jiaohu',
    perms:['bee:ict']
  },
  children: [
    {
      path: 'cec',
      component: cec,
      meta: {icon: 'icon-duijie1', title: i18n.t('zhong-dian-lian-biao-zhun-dui-jie'), perms:['bee:ict:cecCompanyInfo']}
    },
    {
      path: 'secretKey',
      component: () => import("@/module/interactionCenter/page/companySecretKeyManager.vue"),
      meta: {icon: 'icon-duijie1', title: i18n.t('ting-che-xi-tong-dui-jie-0'),perms:['bee:res:secretKey']}
    },
    //{
    //  path: 'dupower',
    //  component: winline,
    //  meta: {icon: 'icon-duijie',title: '度普标准对接'}
    //}
  ]
}]



// WEBPACK FOOTER //
// ./src/module/interactionCenter/router/index.js